const index = function (params = {}) {
    return window.axios.get('/api/holiday-requests', {
        params,
    });
};

export default {
    index,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/HolidayRequestsService.js